import { render, staticRenderFns } from "./RankingYizhi.vue?vue&type=template&id=d4a9ec58&scoped=true&"
import script from "./RankingYizhi.vue?vue&type=script&lang=js&"
export * from "./RankingYizhi.vue?vue&type=script&lang=js&"
import style0 from "./RankingYizhi.vue?vue&type=style&index=0&id=d4a9ec58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a9ec58",
  null
  
)

export default component.exports